export default "__VITE_ASSET__DUVewzuA__"